const FindNewActiveQueryId = (queryIds, activeQueryId, removedQueryIds) => {
  const currentQueryIdIndex = queryIds.indexOf(activeQueryId);
  const priorQueryIds = queryIds.slice(0, currentQueryIdIndex).toList();
  const listToPickNewIdFrom = priorQueryIds.isEmpty() ? queryIds : priorQueryIds.reverse();
  return listToPickNewIdFrom.find((queryId) => !removedQueryIds.includes(queryId));
};
export default FindNewActiveQueryId;
